import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';

// Third-party modules

// Shared modules
import { CoreModule } from '../core';
import { SharedModule } from '../shared';
import { RoutingModule } from './enter.routing';
import { UIModule } from '../ui.module';
import { ToastrModule } from '../toastr.module';
import { SharedDialogsModule } from '../shared-dialogs.module';

// UI Components

// Components of module.
import { BaseComponent } from './base';
import { SCWAccessDiceModule } from './access-dice';
import { LogoComponent } from './logo';
import { AnniversaryBackgroundComponent } from './background';
import { DiceComponent } from './dice';

// Services of module.
import { SeasonsService } from './seasons.service';

@NgModule({
    imports: [
        CommonModule,
        MatSelectModule,
        MatSliderModule,
        MatFormFieldModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        // Third-party modules

        // Shared modules
        CoreModule,
        SharedModule,
        UIModule,
        ToastrModule,
        SharedDialogsModule,
        SCWAccessDiceModule,
        // Current module imports
        RoutingModule
    ],
    declarations: [
        // UI Components

        // Section Components
        BaseComponent,
        LogoComponent,
        AnniversaryBackgroundComponent,
        DiceComponent,
    ],
    exports: [
    ],
    providers: [
        SeasonsService
    ],
    entryComponents: [
    ]
})
export class EnterModule { }
